import { FC, useMemo } from "react";
import { Chip, IconButton, Tooltip } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import { OpenInNew } from "@mui/icons-material";
import { EmbeddedTask } from "@/services/cloudchipr.api";
import { useAppSelector } from "@/store/hooks";
import { taskAvailableStatusPropertiesSelector } from "@/store/task-management/selectors/properties/taskAvailableStatusPropertiesSelector";

interface TaskStatusCellRendererProps {
  task: EmbeddedTask | null;
  onClick?(): void;
}

export const TaskStatusCellRenderer: FC<TaskStatusCellRendererProps> = ({
  task,
  onClick,
}) => {
  const statuses = useAppSelector(taskAvailableStatusPropertiesSelector);

  const status = useMemo(() => {
    return statuses?.find((status) => status.id === task?.status_id);
  }, [statuses, task?.status_id]);

  const deleteIcon = useMemo(
    () => (
      <Tooltip title="View in Task Managment" placement="top" arrow>
        <IconButton
          size="small"
          component={RouterLink}
          target="_blank"
          sx={{ p: 0.2 }}
          to={`${window.location.origin}/task-mgmt?taskId=${task?.id}`}
        >
          <OpenInNew sx={{ color: "white", fontSize: 16 }} />
        </IconButton>
      </Tooltip>
    ),
    [task?.id],
  );

  if (!status) {
    return "-";
  }

  return (
    <Chip
      data-block-row-click
      size="small"
      variant="filled"
      label={status.name}
      deleteIcon={deleteIcon}
      onClick={onClick}
      onDelete={placeholder}
      sx={{
        bgcolor: status.color,
        color: "white",
        cursor: onClick ? "pointer" : "default",
        "&:hover": { bgcolor: status.color, opacity: onClick ? 0.85 : 1 },
      }}
    />
  );
};

const placeholder = () => {};
